import { Spacer, Box, Grid, SpacedDivider, HeaderPrimary } from '@fedsim/components'

export default function TitleBar({ title = '', children = null, TypographyHeader = HeaderPrimary }) {
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'self-end',
              height: '100%'
            }}
          >
            <TypographyHeader>{title}</TypographyHeader>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end'
            }}
          >
            {children}
          </Box>
        </Grid>
      </Grid>
      <SpacedDivider size="small" />
      <Spacer />
    </>
  )
}
